type TranslateFn = (key: string) => string

function humanizeCatalogKey(value: string) {
  return value
    .split('.')
    .flatMap((chunk) => chunk.split('_'))
    .filter(Boolean)
    .map((chunk) => chunk.charAt(0).toUpperCase() + chunk.slice(1))
    .join(' ')
}

export function catalogLabel(value: string, t: TranslateFn) {
  const translationKeys = [
    `rules.slug.${value}`,
    `permissions.slug.${value}`,
    `roles.slug.${value}`,
  ]

  for (const translationKey of translationKeys) {
    const translated = t(translationKey)

    if (translated !== translationKey) {
      return translated
    }
  }

  return humanizeCatalogKey(value)
}
